import styled from 'styled-components';
import { TrashAlt } from '@styled-icons/boxicons-solid/TrashAlt';

export const UploadAreaContainer = styled.div<{ isFacelift: boolean }>`
  display: flex;
  flex-direction: ${({ isFacelift }) => (isFacelift ? 'column' : 'row')};
  width: 100%;
  margin-top: 0.875rem;

  & > span {
    width: 100%;
    margin: 0.5rem;
  }

  & .ant-upload-drag-container {
    width: 100%;

    & > div > span {
      margin-left: -12rem;
      color: #595e69;
      width: 40rem;
    }
  }

  & .upload-button-content {
    max-width: 14rem;
    font-size: 0.75rem;

    & > span {
      font-weight: 700;
    }
  }
`;

export const TrashIcon = styled(TrashAlt)`
  width: 1rem;
  padding-bottom: 0.25rem;
  color: ${({ theme }) => theme.colors.grayDark2};

  &:hover {
    opacity: 0.8;
  }
`;
